export default "__VITE_ASSET__U3hFku0Q__"